<template>
  <div class="FooterComponent">
    <img src="/images/Coventry_City_Council.png" alt="Coventry City Council">
    <img src="/images/Assembly-Festival-Garden.png" alt="Assembly Festival Garden">
  </div>
</template>

<script>
export default {
  name: 'FooterComponent'
}
</script>

<style lang="scss" scoped>
@media (min-width: 992px){
  .FooterComponent{
    position: absolute;
    bottom: 30px;
    right: 90px;

    img{
      width: 100%;
      max-width: 100px;
      min-width: 50px;
    }
    img:first-child{
      margin-right: 15px;
    }
  }
}
@media (max-width: 991px){
  .FooterComponent{
    text-align: center;
    margin-top: 60px;

    img{
      display: block;
      width: 50%;
      max-width: 175px;
      min-width: 100px;
      object-position: center;
      margin: 0 auto;
    }
    img:first-child{
      margin-bottom: 30px;
    }
  }
}
</style>
